import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PopupWindow from './PopupWindow';
import { toQuery } from './utils';

const responseTypeLocationKeys = {
  code: 'search',
  token: 'hash',
  id_token: 'search'
};

const responseTypeDataKeys = {
  code: 'code',
  token: 'access_token',
  id_token: 'code'
};

class OAuth2Login extends Component {
  constructor(props) {
    super(props);
    this.onBtnClick = this.onBtnClick.bind(this);
    this.onRequest = this.onRequest.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onFailure = this.onFailure.bind(this);
  }

  onBtnClick() {
    const {
      buttonText,
      authorizationUrl,
      clientId,
      scope,
      redirectUri,
      state,
      responseType,
      codeChallengeMethod,
      codeChallenge,
      popupWidth,
      popupHeight,
      isCrossOrigin,
      extraParams,
    } = this.props;
    const payload = {
      client_id: clientId,
      scope: scope,
      redirect_uri: redirectUri,
      response_type: responseType,
      code_challenge_method: codeChallengeMethod,
      code_challenge: codeChallenge,
      ...extraParams,
    };
    if (state) {
      payload.state = state;
    }
    const search = toQuery(payload);
    const width = popupWidth;
    const height = popupHeight;
    const left = window.screenX + ((window.outerWidth - width) / 2);
    const top = window.screenY + ((window.outerHeight - height) / 2.5);
    const locationKey = responseTypeLocationKeys[responseType];
    const popup = PopupWindow.open(
      buttonText,
      `${authorizationUrl}?${search}`,
      {
        height, width, top, left,
      },
      {
        locationKey,
        isCrossOrigin,
      },
    );
    this.popup = popup;

    this.onRequest();
    popup
      .then(this.onSuccess)
      .catch(this.onFailure);
  }

  onRequest() {
    const { onRequest } = this.props;
    onRequest();
  }

  onSuccess(data) {
    console.log(data);
    const { responseType, onSuccess, isCrossOrigin } = this.props;
    const responseKey = responseTypeDataKeys[responseType];

    // Cross origin requests will already handle this, let's just return the data
    if (!isCrossOrigin && !data[responseKey]) {
      console.error('received data', data);
      return this.onFailure(new Error(`'${responseKey}' not found in received data`));
    }

    return onSuccess(data);
  }

  onFailure(error) {
    const { onFailure } = this.props;
    onFailure(error);
  }

  render() {
    const {
      id, className, buttonText, children, render,
    } = this.props;

    if (render) {
      return render({
        className, buttonText, children, onClick: this.onBtnClick,
      });
    }
    const attrs = { onClick: this.onBtnClick };
    if (id) {
      attrs.id = id;
    }
    if (className) {
      attrs.className = className;
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <button type="button" {...attrs}>{ children || buttonText }</button>;
  }
}

OAuth2Login.defaultProps = {
  id: undefined,
  buttonText: 'Login',
  scope: '',
  state: '',
  className: '',
  children: null,
  popupWidth: 680,
  popupHeight: 680,
  render: null,
  codeChallengeMethod: '',
  codeChallenge: '',
  isCrossOrigin: false,
  extraParams: {},
  onRequest: () => {},
};

OAuth2Login.propTypes = {
  id: PropTypes.string,
  authorizationUrl: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  redirectUri: PropTypes.string.isRequired,
  responseType: PropTypes.oneOf(['code', 'token', 'id_token']).isRequired,
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  popupWidth: PropTypes.number,
  popupHeight: PropTypes.number,
  className: PropTypes.string,
  render: PropTypes.func,
  codeChallengeMethod: PropTypes.string,
  codeChallenge: PropTypes.string,
  isCrossOrigin: PropTypes.bool,
  onRequest: PropTypes.func,
  scope: PropTypes.string,
  state: PropTypes.string,
  extraParams: PropTypes.object,
};

export default OAuth2Login;

/*
response_type=code
client_id=ee23066a-1088-43ca-b3e2-d2da7d5636a6
scope=openid%20profile%20email%20offline_access%20phone
redirect_uri=https%3A%2F%2Fmaster.dj5dq9npte6en.amplifyapp.com%2F
prompt=login
code_challenge_method=S256
code_challenge=v5_aNW803eMAx9617rm-Hfh7AICAtxdIgkGCCjH2GPw

code_verifier=67f4f1ed232ba9ca97b83f195e0e73032526db5690792143155e46ab
*/